import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Button } from '@material-ui/core';
import classnames from 'classnames';

import styles from './styles';

const ADGMButton = ({ classes, children, variant, className, disabled, ...props }) => {
  const variantClass = useMemo(() => {
    switch (variant) {
      case 'primary':
        return classes.primaryBtn;
      case 'secondary':
        return classes.secondaryBtn;
      case 'tertiary':
        return classes.tertiaryBtn;
      default:
        return classes.primaryBtn;
    }
  }, [variant]);

  return (
    <Button
      className={classnames(classes.btn, variantClass, className, {
        [classes.disabledBtn]: disabled,
      })}
      disabled={disabled}
      {...props}
    >
      {children}
    </Button>
  );
};

ADGMButton.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
};

ADGMButton.defaultProps = {
  variant: 'primary',
  className: '',
  disabled: false,
};

export default withStyles(styles)(ADGMButton);
